module.exports = __webpack_public_path__ + "img/carrot.c759c1c9.svg";